export function useProposalSteps(status: string) {
  const s = (status || '').toUpperCase();
  const isWon = s === 'CLOSED_WON';
  const isNew = s.toLowerCase() === 'new';

  const steps = isNew
    ? ['New', 'In Progress', 'Closed Won']
    : ['New', 'In Progress', isWon ? 'Closed Won' : 'Closed Lost'];

  const activeStep = (() => {
    switch (s) {
      case 'CLOSED_WON':
      case 'CLOSED_LOST':
        return steps[2];
      case 'IN_PROGRESS':
        return steps[1];
      default:
        return steps[0];
    }
  })();

  return { steps, activeStep };
}
